import React from 'react'
import { ReactComponent as StateLogo } from './VT_AOE.svg'
import { Link } from '@tanstack/react-router'

export default function VermontLogo() {
  return (
    <div>
      <Link to="/">
        <StateLogo style={{ height: '75px' }} className="vermont-logo-mobile" />
      </Link>
    </div>
  )
}
